import {
    CREATE_KNITTING_INWARD_FAILURE,
    CREATE_KNITTING_INWARD_REQUEST,
    CREATE_KNITTING_INWARD_SUCCESS,
    CREATE_USER_FORM_KNITTING_INWARD,
    FETCH_SINGLE_KNITTING_INWARD_FAILURE,
    FETCH_SINGLE_KNITTING_INWARD_REQUEST,
    FETCH_SINGLE_KNITTING_INWARD_SUCCESS,
    FETCH_KNITTING_INWARD_FAILURE,
    FETCH_KNITTING_INWARD_REQUEST,
    FETCH_KNITTING_INWARD_SUCCESS,
    NAVIGATE_KNITTING_INWARD_DETAILS,
    NAVIGATE_KNITTING_INWARD,
    KNITTING_INWARD_USERFORM_RESET,
    UPDATE_KNITTING_INWARD_FAILURE,
    UPDATE_KNITTING_INWARD_REQUEST,
    UPDATE_KNITTING_INWARD_SUCCESS,
    DELETE_KNITTING_INWARD_REQUEST,
    DELETE_KNITTING_INWARD_SUCCESS,
    DELETE_KNITTING_INWARD_FAILURE,
    FETCH_PENDING_KNITTING_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_KNITTING_PO_IN_INWARD_SUCCESS,
    FETCH_PENDING_KNITTING_PO_IN_INWARD_FAILURE,
    SET_ACTIVE_KEY_KNITTING_INWARD,
    RESET_FORM_DATA_WITHOUT_KNITTING_INWARD_ID,
    SET_END_DATE_KNITTING_INWARD,
    SET_START_DATE_KNITTING_INWARD,
    SET_UNIT_NAME_KNITTING_INWARD
} from './knittingInward.actionsType';

export const KNITTING_INWARD = 'knittingInward';

let initialState = {
    loading: false,
    knittingInward: [],
    pendingKnittingDC: [],
    activeKey: 1,
    knittingInwardId: '',
    knittingInwardMasterForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,

        fldRoundoff: 0
    },
    selectedKnittingInward: {},
    isKnittingInward: false,
    knittingInwardSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    goBack: true,
    unitId: '',
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),
};

export let knittingInwardReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_KNITTING_INWARD_REQUEST:
        case FETCH_PENDING_KNITTING_PO_IN_INWARD_REQUEST:
        case CREATE_KNITTING_INWARD_REQUEST:
        case FETCH_SINGLE_KNITTING_INWARD_REQUEST:
        case UPDATE_KNITTING_INWARD_REQUEST:
        case DELETE_KNITTING_INWARD_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_KNITTING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingInward: updatePayload
            };
        case FETCH_PENDING_KNITTING_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingKnittingDC: updatePayload
            };
        case CREATE_KNITTING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                knittingInwardId: updatePayload[0],
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case FETCH_SINGLE_KNITTING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedKnittingInward: updatePayload,
                knittingInwardMasterForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_KNITTING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedKnittingInward: {},
                knittingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                }
            };
        case DELETE_KNITTING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                selectedKnittingInward: {}
            };
        case FETCH_KNITTING_INWARD_FAILURE:
        case FETCH_PENDING_KNITTING_PO_IN_INWARD_FAILURE:
        case FETCH_SINGLE_KNITTING_INWARD_FAILURE:
        case CREATE_KNITTING_INWARD_FAILURE:
        case UPDATE_KNITTING_INWARD_FAILURE:
        case DELETE_KNITTING_INWARD_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_KNITTING_INWARD:
            return {
                ...state,
                loading: false,
                knittingInwardMasterForm: {
                    ...state.knittingInwardMasterForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_KNITTING_INWARD:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case KNITTING_INWARD_USERFORM_RESET:
            return {
                ...state,
                knittingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                selectedKnittingInward: {},
                knittingInwardId: '',
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_KNITTING_INWARD_ID:
            return {
                ...state,
                knittingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_KNITTING_INWARD_DETAILS:
            return {
                ...state,
                isKnittingInward: true,
                knittingInwardSelectedValue: updatePayload.knittingInwardSelectedValue
            };
        case NAVIGATE_KNITTING_INWARD:
            return {
                ...state,
                isKnittingInward: false,
                goBack: false

            };
            case SET_UNIT_NAME_KNITTING_INWARD:
            return {
                ...state,
                unitId: payload
            };
            case SET_START_DATE_KNITTING_INWARD:
            return {
                ...state,
                startDate: payload
            };
            case SET_END_DATE_KNITTING_INWARD:
            return {
                ...state,
                endDate: payload
            };
        default:
            return state;
    }
};
